<template>
  <div class="critical-document-wrapper">
    <div class="page-sheet">
      <!-- Encabezado Oficial -->
      <table class="header-table">
        <tbody>
          <tr>
            <td class="header-logo-cell">
              <img src="/static/logo_sp.png" alt="Sunshine" class="company-logo" />
            </td>
            <td class="header-title-cell">
              <div class="main-title">DESIGNACION DE PUESTO<br />CRITICO EN LA CADENA DE<br />SUMINISTROS</div>
            </td>
            <td class="header-meta-cell">
              <div><strong>Código :</strong> SIG-CS-RH-FR-039</div>
              <div><strong>Versión :</strong> 03</div>
              <div><strong>Fecha de Creación :</strong> 02/12/2021</div>
              <div><strong>Última Revisión :</strong> 15/07/2025</div>
              <div><strong>Página :</strong> 1 de 1</div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Referencia y Fecha -->
      <table class="reference-table">
        <tbody>
          <tr>
            <td class="reference-cell">
              <strong>Referencia:</strong> Normas Internacionales de Seguridad en la Cadena de Suministros.
            </td>
            <td class="date-cell">
              <strong>Fecha:</strong> {{ formattedDate }}
            </td>
          </tr>
        </tbody>
      </table>

      <!-- I. DATOS GENERALES DEL TRABAJADOR -->
      <div class="section-banner mt-3">I. DATOS GENERALES DEL TRABAJADOR</div>
      <div class="meta-container mt-2 font-size-12">
        <div class="meta-row">
          <span class="meta-label">NOMBRE:</span>
          <span class="meta-value">{{ workerData.NtpFullName || '' }}</span>
          <span class="meta-label ml-3">DNI N°:</span>
          <span class="meta-value-short">{{ workerData.PrsDocumentNumber || '' }}</span>
        </div>
        <div class="meta-row mt-2">
          <span class="meta-label">DIRECCION:</span>
          <span class="meta-value">{{ workerData.Address || '' }}</span>
          <span class="meta-label ml-3">Teléfono:</span>
          <span class="meta-value-short">{{ workerData.Phone || '' }}</span>
        </div>
      </div>

      <!-- II. DESCRIPCION DEL PUESTO -->
      <div class="section-banner mt-3">II. DESCRIPCION DEL PUESTO</div>
      <div class="position-box-container mt-3">
        <div class="position-row">
          <span class="position-label">NOMBRE DEL PUESTO:</span>
          <div class="position-frame">{{ workerData.PstName || '' }}</div>
        </div>
        <div class="position-row mt-2">
          <span class="position-label">AREA DEL PUESTO:</span>
          <div class="position-frame">{{ workerData.AreName || '' }}</div>
        </div>
      </div>

      <!-- III. IDENTIFICACION DE PUESTO CRITICO -->
      <div class="section-banner mt-4">III. IDENTIFICACION DE PUESTO CRITICO</div>
      <div class="legal-text mt-3 text-justify line-height-14 font-size-115">
        <p class="mb-2">
          Por medio del presente, <strong>SUNSHINE EXPORT S.A.C.</strong> le hace de conocimiento a <strong>EL TRABAJADOR</strong> ocupante del cargo que en el desempeño de sus funciones realiza trabajos de acceso a zonas sensibles y críticas según los protocolos de seguridad en la cadena de suministros, en cumplimiento con los procedimientos de acceso y asumiendo la responsabilidad de toda actividad ilícita. En ese sentido, manifiesta su pleno consentimiento para cuando le sea requerido por La Empresa se someta a todos los exámenes médicos, toxicológicos o de cualquier otra índole que considere pertinente. Asimismo, otorgará su conformidad y brindará todas las facilidades para que la Empresa pueda realizar la correspondiente visita domiciliaria por parte de la Trabajadora Social, en el domicilio consignado en la presente comunicación; en caso de variación de domicilio, el trabajador deberá proporcionar oportunamente y por escrito su nueva dirección ante la oficina de Recursos Humanos.
        </p>
        <p class="mb-2">
          En caso de negativa de lo aquí estipulado constituye falta grave que se puede sancionar con Despido.
        </p>
        <p class="mb-2">
          Cualquier información adicional que Ud. requiera conocer será proporcionada por la Jefatura de Administración de Personal y Compensaciones.
        </p>
        <div class="mb-1"><strong>Normas y/o Protocolos de Referencia:</strong></div>
        <ol class="standards-list pl-4 mb-0">
          <li>Norma BASC V06:2022 y el Estándar 6.01</li>
          <li>Checklist Supply Chain Security - Walmart Mayo -2024</li>
        </ol>
      </div>

      <!-- Sección Firmas -->
      <table class="signatures-table mt-6">
        <tbody>
          <tr>
            <td class="worker-sig-cell">
              <div class="sig-boxes-duo">
                <div class="sig-space"></div>
                <div class="fingerprint-space"></div>
              </div>
              <div class="sig-labels-duo">
                <span class="sig-label-part">FIRMA DEL TRABAJADOR</span>
                <span class="fingerprint-label-part">HUELLA</span>
              </div>
            </td>
            <td class="company-sig-cell">
              <div class="sig-space-single"></div>
              <div class="sig-label-single">FIRMA DE RESPONSABLE DE RR.HH.</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "CriticalPositionDesignation",
  props: {
    workerData: {
      type: Object,
      default: () => ({}),
    },
    documentDate: {
      type: String,
      default: null,
    },
  },
  computed: {
    formattedDate() {
      const raw = this.documentDate || this.workerData.AgtBeginDate;
      if (raw) {
        const parts = String(raw).substring(0, 10).split("-");
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
      }
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, "0");
      const mm = String(now.getMonth() + 1).padStart(2, "0");
      const yyyy = now.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    },
  },
};
</script>

<style scoped>
.critical-document-wrapper {
  font-family: Arial, sans-serif;
  color: #000;
  background: transparent;
}

.page-sheet {
  background: #ffffff;
  width: 100%;
  max-width: 760px;
  min-height: 1060px;
  margin: 0 auto 30px auto;
  padding: 30px 40px;
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  position: relative;
}

.header-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

.header-table td {
  border: 1px solid #000;
  vertical-align: middle;
  padding: 8px 6px;
}

.header-logo-cell {
  width: 25%;
  text-align: center;
}

.company-logo {
  max-width: 125px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.header-title-cell {
  width: 45%;
  text-align: center;
}

.main-title {
  font-size: 13.5px;
  font-weight: bold;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  line-height: 1.25;
}

.header-meta-cell {
  width: 30%;
  font-size: 9px;
  line-height: 1.35;
  padding-left: 8px !important;
}

.reference-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
  border-top: none;
  font-size: 11px;
}

.reference-table td {
  padding: 6px 8px;
  border-right: 1px solid #000;
}

.reference-cell {
  width: 65%;
}

.date-cell {
  width: 35%;
  text-align: right;
  border-right: none !important;
}

.section-banner {
  font-size: 12px;
  font-weight: bold;
  padding: 4px 10px;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  background-color: #fafafa;
  letter-spacing: 0.3px;
}

.font-size-115 {
  font-size: 11.5px;
}

.font-size-12 {
  font-size: 12px;
}

.line-height-14 {
  line-height: 1.4;
}

.meta-container {
  padding: 0 4px;
}

.meta-row {
  display: flex;
  align-items: baseline;
}

.meta-label {
  font-weight: bold;
  white-space: nowrap;
  margin-right: 6px;
}

.meta-value {
  flex: 1;
  border-bottom: 1px dashed #000;
  padding: 0 4px;
  min-height: 18px;
}

.meta-value-short {
  width: 160px;
  border-bottom: 1px dashed #000;
  padding: 0 4px;
  min-height: 18px;
}

.position-box-container {
  padding: 0 40px;
}

.position-row {
  display: flex;
  align-items: center;
}

.position-label {
  width: 180px;
  font-weight: bold;
  font-size: 12px;
}

.position-frame {
  flex: 1;
  border: 1px solid #000;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
  background-color: #fff;
  padding: 0 8px;
  text-align: center;
}

.standards-list {
  margin: 0;
}

.standards-list li {
  margin-bottom: 2px;
}

.signatures-table {
  width: 100%;
  border-collapse: collapse;
}

.signatures-table td {
  vertical-align: top;
  padding: 0 16px;
}

.worker-sig-cell {
  width: 50%;
}

.company-sig-cell {
  width: 50%;
}

.sig-boxes-duo {
  display: flex;
  height: 95px;
  border: 1px solid #000;
}

.sig-space {
  flex: 3;
  border-right: 1px solid #000;
}

.fingerprint-space {
  flex: 1;
}

.sig-labels-duo {
  display: flex;
  border: 1px solid #000;
  border-top: none;
  font-size: 11px;
  font-weight: bold;
  text-align: center;
}

.sig-label-part {
  flex: 3;
  border-right: 1px solid #000;
  padding: 4px;
}

.fingerprint-label-part {
  flex: 1;
  padding: 4px;
}

.sig-space-single {
  height: 95px;
  border: 1px solid #000;
}

.sig-label-single {
  border: 1px solid #000;
  border-top: none;
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  padding: 4px;
}

@media print {
  .page-sheet {
    page-break-after: always;
    break-after: page;
    border: none;
    box-shadow: none;
    margin: 0;
    padding: 10mm 15mm;
    min-height: 275mm;
  }
}
</style>
